import querystring from 'querystring'
export default class qqAuth {
  constructor(config) {
    const defaultConfig = {
      client_id: '',
      responseType: 'token',
      scope: 'get_user_info',
      redirectUri: '', // QQ登录成功回调地址
    }
    this.config = Object.assign(defaultConfig, config)
  }

  getUrlAccessToken(hash) {
    if (hash) {
      return querystring.parse(hash.replace('#access_token=', 'access_token='))
        .access_token
    }
    return null
  }

  // 获取授权页面url
  getAuthUrl() {
    let url = ''
    if (this.config.redirectUri) { // 优先config下的redirectUri
      url = this.config.redirectUri
    } else { // 当前页面的url
      url = location.href.split('?')[0]
      // 构建后参数前面自动带了斜杆, 所以去掉最后的斜杆
      url = url.replace(/\/$/g, '')
      url = `${url}?${location.search}`
    }
    const redirectUri = encodeURIComponent(url)

    const authPageBaseUri = 'https://graph.qq.com/oauth2.0/authorize'
    const authParams = `?client_id=${this.config.client_id}&response_type=${this.config.responseType}&redirect_uri=${redirectUri}&scope=${this.config.scope}`
    return authPageBaseUri + authParams
  }

  openAuthPage() {
    window.location.href = this.getAuthUrl()
  }
}
